import { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import { IoIosArrowBack } from 'react-icons/io';
import { Spinner } from 'react-bootstrap';
import { HiPlusCircle } from 'react-icons/hi';
import PopOver from '../../../../Components/PopOver/PopOver';
import GetDataApi from '../../../../Components/Common/FetchData/GetDataApi';
import DeleteDataApi from '../../../../Components/Common/FetchData/DeleteDataApi';
import CreateMyLead from './CreateMyLead';
import { ILeadType } from './type/leadType';
import CommAccordian from '../../../../Components/Common/CommAccordian';

import ExcelGenerator from '../../../Common/excel/ExcelGenerator';
import moment from 'moment';
const MyLeads = () => {
  const [toggle, setToggle] = useState<boolean>(false);
  const { response, loading, getData } = GetDataApi<ILeadType[]>(
    `/api/fair/exhibitor/lead`,
    true
  );
  const { deleteData, success, setSuccess } = DeleteDataApi(
    '/api/fair/exhibitor/lead/'
  );

  useEffect(() => {
    (async () => {
      getData();
    })();
    if (success) {
      setSuccess(false);
    }
  }, [toggle, success]);

  return (
    <>
      <div className='profile-right-side px-3 py-3'>
        {toggle ? (
          <div className='product-header  d-flex align-items-center justify-content-between '>
            <h4>Add New My Leads (Exhibition)</h4>
            <div onClick={() => setToggle(false)} className='pointer'>
              <p
                style={{
                  backgroundColor: '#1982c3',
                  color: 'white',
                  padding: '5px 7px',
                  borderRadius: '5px',
                }}
              >
                <IoIosArrowBack className='mb-1 me-1' />
                Back to list
              </p>
            </div>
          </div>
        ) : (
          <div className='d-flex  align-items-center justify-content-between'>
            <h4>My Leads (Exhibition)</h4>

            <div className='d-flex align-items-center gap-2'>
              <ExcelGenerator
                excelName={`Leads`}
                excelTableHead={[
                  'Name',
                  'Phone',
                  'Email',
                  'Address',
                  'Cus. Interest',
                ]}
                excelData={
                  response?.length
                    ? response?.map((sData) => {
                        const data = {
                          Date: moment(sData.created_at).format('YYYY-MM-DD'),
                          Name: sData?.name,
                          Phone: sData.phone,
                          Email: sData.email,
                          Address: sData.address,
                          'Cus. Interest': sData.details,
                        };
                        return data;
                      })
                    : []
                }
              />
              <span
                style={{
                  backgroundColor: '#1982c3',
                  color: 'white',
                  padding: '5px 7px',
                  borderRadius: '5px',
                }}
                onClick={() => setToggle(!toggle)}
              >
                {' '}
                <HiPlusCircle className='mb-1 me-1 ' />
                Add My Leads
              </span>
            </div>
          </div>
        )}

        {toggle ? (
          <CreateMyLead setToggle={setToggle} />
        ) : (
          <div className='profile-right-info pt-3 ps-2'>
            {loading ? (
              <div className='text-center mt-3'>
                <Spinner animation='border' variant='primary' />
              </div>
            ) : (
              <>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th className='text-center'>SL.</th>
                      <th className='text-center'>Name</th>
                      <th className='text-center'>Phone</th>
                      <th className='text-center'>Email</th>
                      <th className='text-center'>Address</th>
                      <th className='text-center'>Cus. Interest</th>
                      <th className='text-center'>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      {response && response?.length ? (
                        response?.map((sProduct, index) => {
                          return (
                            <tr key={sProduct.id}>
                              <td className='text-center'>{index + 1}</td>
                              <td className='text-center'>{sProduct.name}</td>
                              <td className='text-center'>{sProduct.phone}</td>
                              <td className='text-center'>{sProduct.email}</td>
                              <td className='text-center'>
                                {sProduct.address}
                              </td>
                              <td className='text-center' width={150}>
                                <CommAccordian text={sProduct.details} />
                              </td>

                              <td align='center'>
                                <PopOver
                                  confirm={() => {
                                    deleteData(sProduct.id);
                                  }}
                                />
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr className='text-center'>
                          <td colSpan={6} className='fw-bold'>
                            No data found
                          </td>
                        </tr>
                      )}
                    </>
                  </tbody>
                </Table>
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default MyLeads;
